import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      sortable: true,
    },
    {
      prop: 'name',
      label: i18n.t('inventory.article_category'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'name',
      label: `${i18n.t('inventory.articles')}`,
      show: false,
      articleCategory: true,
    },
    {
      prop: 'description',
      label: `${i18n.t('common_words.description')}`,
      minWidth: 200,
      sortable: true,
    },
  ];

  return { tableColumns };
};

export default configTable;
